import { queryOptions } from '@tanstack/react-query';
import { privateClient } from '../axiosClients/axiosClients';

export async function getEstimatedCostandEffort(params) {
  const response = await privateClient.get(
    `/EstimatedCostandEffort?pecrId=${params.pecrId}&siteId=${params.siteId}`
  );
  return response.data;
}

export function createGetEstimatedCostandEffortOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['getEstimatedCostandEffort', params],
    queryFn: () => getEstimatedCostandEffort(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
